import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import { 
    submitCDAPService,submitMainFormService
} from "../services";

export const submitCDAPForm = createAsyncThunk('submitForm/postCDAPForm', async(data) => {
    try {
     const response = await submitCDAPService(data);
     return response.data;
    } catch (error) {
     console.log(error);
    } 
 });

 export const submitMainForm = createAsyncThunk('submitForm/postMainForm', async(data) => {
    try {
     const response = await submitMainFormService(data);
     return response.data;
    } catch (error) {
     console.log(error);
    } 
 });


const initialState = {
    isSubmitting: false,    
    CDAPFormSubmission: "",
    mainFormSubmission: "",
}


const submitFormSlice = createSlice({
    name: "submitForm",
    initialState,
    reducers: {
        setCDAPFormSubmission: (state,action) => {
            state.CDAPFormSubmission[action.payload.name] = action.payload.value;
        }
    },
    extraReducers: (builder) => {

        //Submit CDAP Form:
        builder.addCase(submitCDAPForm.pending,(state)=>{
            state.isSubmitting=true;
        }).addCase(submitCDAPForm.fulfilled,(state,action)=>{
            state.isSubmitting=false;
            state.CDAPFormSubmission = action.payload
        }).addCase(submitCDAPForm.rejected,(state)=>{
            state.isSubmitting=false;
        });        

        //Submit Regular Form:
        builder.addCase(submitMainForm.pending,(state)=>{
            state.isSubmitting=true;
        }).addCase(submitMainForm.fulfilled,(state,action)=>{
            state.isSubmitting=false;
            state.mainFormSubmission = action.payload
        }).addCase(submitMainForm.rejected,(state)=>{
            state.isSubmitting=false;
        });           

    }
})

export const {setCDAPFormSubmission}=submitFormSlice.actions;
export default submitFormSlice.reducer;